export default "__VITE_ASSET__CU7EbUaV__"